function detectFrameRate() {
    return new Promise((resolve) => {
        const numFrames = 30;
        const startTime = performance.now();

        let i = 0;

        const tick = () => {
            if (i < numFrames) {
                i += 1;
                requestAnimationFrame(tick);
                return;
            }

            const frameRate = numFrames / ((performance.now() - startTime) / 1000);

            resolve(frameRate);
        };

        requestAnimationFrame(tick);
    });
}

function detectPowerSavingMode() {
    const isAppleDevice = /(iP(?:hone|ad|od)|Mac OS X|Macintosh)/.test(navigator.userAgent);

    if (isAppleDevice) {
        return new Promise((resolve) => {
            const fps = 60;
            const interval = 1000 / fps;
            const numFrames = 30;
            const startTime = performance.now();

            let i = 0;

            const handle = setInterval(() => {
                if (i < numFrames) {
                    i += 1;
                    return;
                }

                clearInterval(handle);

                const actualInterval = (performance.now() - startTime) / numFrames;
                const ratio = actualInterval / interval;

                resolve(ratio > 1.3);
            }, interval);
        });
    }

    return detectFrameRate().then((frameRate) => {
        if (frameRate < 34) {
            return true;
        }

        if ("getBattery" in navigator) {
            return navigator.getBattery().then((battery) => !battery.charging && battery.level <= 0.2);
        }

        return false;
    });
}

class DeviceController {
    constructor() {
        this._isMac = false;
        this._isSafari = false;
        this._isMobile = false;
    }

    init() {
        this._isMac = /(macintosh|macintel|macppc|mac68k|macos)/i.test(navigator.userAgent);
        this._isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        this._isMobile = window.matchMedia("(max-width: 1024px)").matches;
    }

    get isMac() {
        return this._isMac;
    }

    get isSafari() {
        return this._isSafari;
    }

    get isMobile() {
        return this._isMobile;
    }

    get isLowPower() {
        return detectPowerSavingMode();
    }
}

if (!window.__aareDevice) {
    window.__aareDevice = new DeviceController();
    window.__aareDevice.init();
}

export default window.__aareDevice;